import React, {
  useRef,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import { ShareContext } from "../contexts/ShareContext";
import SignatureCanvas from "react-signature-canvas";

const SignaturePad = forwardRef(
  (
    { setBase64 = () => {}, isDisabled = false, passengerFullname = "" },
    ref
  ) => {
    const { msg } = useContext(ShareContext);
    const sigCanvas = useRef();

    // ✅ ลบลายเซ็นและรีเซ็ต base64
    const clearCanvas = () => {
      if (sigCanvas.current) {
        sigCanvas.current.clear();
        setBase64("");
      }
    };

    // ✅ export ฟังก์ชัน clearCanvas ให้ component อื่นเรียกได้
    useImperativeHandle(ref, () => ({
      clearCanvas,
    }));

    // ✅ ฟังก์ชันเรียกหลังเซ็นเสร็จ (เก็บ base64)
    const handleEnd = () => {
      if (sigCanvas.current && !isDisabled) {
        const dataURL = sigCanvas.current.toDataURL("image/png");
        setBase64(dataURL);
      }
    };

    return (
      <div className="signaturePad">
        <SignatureCanvas
          ref={sigCanvas}
          penColor={isDisabled ? "transparent" : "black"} // ปิดการเซ็นถ้า disable
          canvasProps={{
            width: 400,
            height: 150,
            className: "sigCanvas",
          }}
          onEnd={handleEnd} // ✅ เมื่อเซ็นเสร็จจะเก็บ base64
          clearOnResize={false}
        />
        {isDisabled && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "150px",
              top: 0,
              left: 0,
              backgroundColor: "rgba(255,255,255,0.5)",
              cursor: "not-allowed",
            }}
          ></div>
        )}
      </div>
    );
  }
);

export default SignaturePad;
